const localStorageKey = 'professional-disclaimer'

export default {
    get: () => {
        return parseInt(sessionStorage.getItem(localStorageKey)) || 0
    },

    set: (disclaimer) => {
        sessionStorage.setItem(localStorageKey, (disclaimer ? 1 : 0));
    }
}